<template>
  <!-- 修改密码 -->
  <el-dialog
    title="信息变更-密码设置"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="set-password-dialog"
  >
    <div class="content-wrap">
      <el-form
        autocomplete="off"
        label-position="top"
        ref="setPasswordForm"
        :model="setPasswordForm"
        size="medium"
        class="setPasswordForm"
        :rules="setPasswordRules"
        key="setPasswordForm"
        hide-required-asterisk
      >
        <el-form-item label="手机号：" class="mobile-item">
          <p class="mobile">{{ user && user.mobile ? user.mobile : "" }}</p>
          <el-button type="text" @click="sendCode" :disabled="sending">{{
            buttonText
          }}</el-button>
        </el-form-item>
        <el-form-item label="" prop="code">
          <el-input
            autocomplete="off"
            v-model.trim="setPasswordForm.code"
            maxlength="6"
            placeholder="请输入验证码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model.trim="setPasswordForm.password"
            maxlength="18"
            placeholder="8-18位字母、数字、字符、区分大小写"
            autocomplete="new-password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="再次输入密码" prop="re_password">
          <el-input
            v-model.trim="setPasswordForm.re_password"
            maxlength="18"
            autocomplete="new-password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <button class="default-btn" @click="handleClose" v-preventReClick>
        取消
      </button>
      <button
        class="primary-btn"
        @click="submitByCodeForm"
        :disabled="submitDisabled"
        v-preventReClick
      >
        提交
      </button>
    </span>
  </el-dialog>
</template>

<script>
import { sendCode } from "@saas/server-api/src/index.js";
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify";
import { mapGetters } from "vuex";
import { setPassword } from "@saas/server-api/src/user-info/index";
export default {
  mixins: [ManMachineVerify],
  data: function () {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.setPasswordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9\s]).{8,}$/;
      if (!regex.test(value)) {
        callback(
          new Error("密码必须至少8位，且包含数字、字母和至少一个特殊字符")
        );
      } else {
        callback();
      }
    };
    return {
      sending: false,
      dialogVisible: false,
      setPasswordForm: {},
      buttonText: "获取验证码",
      buttonTimer: null,
      time: 60,
      setPasswordRules: {
        code: [{ required: true, message: "必填项", trigger: "blur" }],
        password: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        re_password: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      loading: false,
    };
  },
  beforeDestroy() {
    clearInterval(this.buttonTimer);
  },
  methods: {
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      let params = {
        account: this.user.mobile,
        randstr: res.randstr,
        scene: "SetPassword",
        ticket: res.ticket,
      };
      this.sending = true;
      sendCode(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("验证码已发送");
            this.timer();
          } else {
            this.$message.error(res.message);
            this.sending = false;
          }
        })
        .catch(() => {
          this.sending = false;
        });
    },
    timer() {
      this.buttonTimer = setInterval(() => {
        if (this.time < 1) {
          clearInterval(this.buttonTimer);
          this.buttonText = "获取验证码";
          this.sending = false;
          this.time = 60;
        } else {
          this.time = this.time - 1;
          this.buttonText = `${this.time}s后重新发送`;
        }
      }, 1000);
    },
    sendCode() {
      // 发送验证码前需要人机验证
      this.showCaptcha();
    },
    submitByCodeForm() {
      this.$refs.setPasswordForm.validate((valid) => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          let params = {
            ...this.setPasswordForm,
            account: this.user.mobile,
            is_verify: 2,
          };
          setPassword(params)
            .then((res) => {
              if (res.code === 1) {
                this.handleClose();
                this.$emit("success");
              } else {
                this.$message.error(res.message);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.sending = false;
      this.setPasswordForm = {};
      this.code = "";
      this.buttonText = "获取验证码";
      if (this.buttonTimer) {
        clearInterval(this.buttonTimer);
        this.buttonTimer = null;
      }
      this.time = 60;
      this.codePassed = false;
      if (this.$refs["setPasswordForm"]) {
        this.$refs["setPasswordForm"].clearValidate();
      }
    },
    showDialog() {
      this.dialogVisible = true;
    },
  },
  computed: {
    ...mapGetters(["user"]),
    submitDisabled() {
      let { code, password, re_password } = this.setPasswordForm;
      if (code && password && re_password) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.set-password-dialog {
  ::v-deep .el-dialog {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0 !important;
    height: 432px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(156, 175, 154, 0.17);
    border-radius: 24px;
    .el-dialog__header {
      padding-top: 24px;
      padding-bottom: 0;
      text-align: center;
      font-weight: 500;
      .el-dialog__title {
        font-size: 20px;
        color: #0d1400;
        line-height: 28px;
      }
    }
    .el-dialog__body {
      padding: 24px;
    }
    .el-dialog__headerbtn {
      top: 15px;
    }
    .el-dialog__close {
      color: #4e5969;
      font-size: 14px;
      font-weight: bold;
    }
    .el-dialog__footer {
      padding-top: 0;
    }
  }
}
.content-wrap {
  ::v-deep .setPasswordForm {
    .el-form-item__label {
      padding-bottom: 8px;
      font-weight: 400;
      font-size: 14px;
      color: #0d1400;
      line-height: 20px;
    }
  }

  ::v-deep .mobile-item {
    display: flex;
    align-items: center;
    &.el-form-item {
      margin-bottom: 3px;
    }
    button {
      margin-left: 50px;
      font-size: 16px;
      color: #00c89d;
    }
    .el-form-item__label {
      padding-bottom: 0;
    }
    .el-form-item__label,
    .el-form-item__content {
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
    }
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-btn,
.primary-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 78px;
  height: 36px;
  background: #f7f8f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #0d1400;
  line-height: 22px;
}
.primary-btn {
  background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  color: #fff;
  margin-left: 16px;
}
::v-deep .is-required .el-form-item__label::after {
  content: "*";
  color: #ff0000;
  margin-left: 4px;
}
</style>
